(() => {
  const rand = (min, max) => Math.random() * (max - min) + min;

  /* Seed the hover-snow flakes once per button. Negative animation delays mean
     flakes are already mid-air the instant the pointer enters the pill. */
  function seedSnow(container) {
    if (container.dataset.seeded) return;
    container.dataset.seeded = 'true';
    const count = parseInt(container.dataset.snowCount || '16', 10);
    const frag = document.createDocumentFragment();
    for (let i = 0; i < count; i++) {
      const f = document.createElement('i');
      f.style.setProperty('--x', rand(4, 96) + '%');
      f.style.setProperty('--s', rand(2, 4).toFixed(1) + 'px');
      f.style.setProperty('--d', rand(2.6, 4.8).toFixed(2) + 's');
      f.style.setProperty('--delay', (-rand(0, 4.8)).toFixed(2) + 's');
      f.style.setProperty('--o', rand(0.45, 0.95).toFixed(2));
      frag.appendChild(f);
    }
    container.appendChild(frag);
  }

  function init(root) {
    (root || document).querySelectorAll('.btn--snow .gp-snow').forEach(seedSnow);
  }

  /* Cursor-follow flare, via delegation so theme-editor section rerenders keep working */
  document.addEventListener('pointermove', (event) => {
    const button = event.target instanceof Element ? event.target.closest('.btn--snow') : null;
    if (!button) return;
    const rect = button.getBoundingClientRect();
    button.style.setProperty('--mx', (event.clientX - rect.left) + 'px');
    button.style.setProperty('--my', (event.clientY - rect.top) + 'px');
  });

  init();
  document.addEventListener('shopify:section:load', (event) => init(event.target));
})();
